import React from "react";
import { Link } from "react-router-dom";
import TitlePanel from "../titles_page/title_panel/TitlePanel";

import "./SubtitlesPage.css"

var definite_sum_calculation_formula = "$sum_(k=0)^nk^2$";
var double_sum_formula = "$sum_(i=0)^n sum_(j=0)^m (i + j)$";
var series_formula = "$sum_(n=0)^(+infty)U_n$";
var series_of_functions_formula = "$sum_(n > 0)f_n(x)$";
var series_memory_map = "Explore the Mind Map on series! 🧠"

const SubtitlesPageAdvancedSeries = () => {
    return (
        <div className="titles-page-div">
            <div className="choose-topic-div">
                <h2>Choose a topic</h2>
            </div>
            <div className="titles-container">
                <Link to="/advanced/series/memory_map" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Series Mind Map" formula={series_memory_map}/>
                </Link>

                <Link to="/advanced/series/definite_sum_calculation" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Definite Sum Calculation" formula={definite_sum_calculation_formula}/>
                </Link>

                <Link to="/advanced/series/double_sum" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Double Sum" formula={double_sum_formula}/>
                </Link>

                <Link to="/advanced/series/series" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Series" formula={series_formula}/>
                </Link>

                <Link to="/advanced/series/series_of_functions" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Series of Functions" formula={series_of_functions_formula}/>
                </Link>
            </div>
        </div> 
    );
}

export default SubtitlesPageAdvancedSeries;